import { render } from "./PalletPrint.vue?vue&type=template&id=e4c295c8&scoped=true"
import script from "./PalletPrint.vue?vue&type=script&lang=js"
export * from "./PalletPrint.vue?vue&type=script&lang=js"

import "./PalletPrint.vue?vue&type=style&index=0&id=e4c295c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c295c8"]])

export default __exports__